<template>
  <Layout>
    <SubHeader slot="sub-header" 
      :title="$t('licence.title')"
      :isBackground="true">
    </SubHeader>
    <div slot="body" class="user-licence-container">
      <div class="user-licence">
        <img src="/static/images/ic-license-code.svg" class="licence-icon" />
        <h5
          class="licence-title" 
          v-if="isUserLicence"
          v-html="$t('licence.register_confirm', { user: currentUserName })"
        >
        </h5>
        <h4
          class="licence-title"
          v-else
          v-html="$t('licence.form_title')">
        </h4>

      <div v-if="isUserLicence" class="licence-card">
        <h5 class="licence-card-title">{{ $t('licence.sub_title') }}</h5>
        <div class="licence-card-subtitle">{{ $t('licence.register_period') }}</div>
        <div class="licence-card-date">{{ licenceStartDate }}~{{licenceEndDate}}</div>
      </div>

      <div v-else class="row form-group">
        <input
          type="text"
          class="form-control licence-code-field" 
          v-model="licenceCode"
          :placeholder="fieldPlaceholder"
          required />
        <button
          type="button"
          class="licence-code-btn"
          @click="submitLicenceCode()"
          :disabled="!isLicenceCode || busy" >
          <LoadingBounce v-if="busy" />
          <template v-else>{{ $t('licence.register') }}</template>
        </button>
        </div>
      </div>
      
      <div class="licence-benefit">
        <h5 class="benefit-title">{{ $t('licence.benefit_title') }}</h5>
        <div class="benefit-item" v-for="(item, index) in benefitItems" :key="index">
          <img src="/static/images/ic-check.svg" alt="icon"> {{ item }}
        </div>
      </div>

      <CustomModal
        id="content-report-success-modal"
        class="basic-modal no-header-modal hide-cancel-btn content-report-modal"
        :hide-header="false"
        :title="$t('licence.register_success')"
        :isCloseButton="false"
        :ok-title="$t('common.confirmation')"
        @ok="isSuccess = false"
        v-if="isSuccess">
        <div v-html="successText"></div>
      </CustomModal>

      <CustomModal
        id="content-report-success-modal"
        class="basic-modal no-header-modal hide-cancel-btn content-report-modal"
        :hide-header="true"
        :isCloseButton="false"
        :ok-title="$t('common.confirmation')"
        @ok="isError = false"
        v-if="isError">
        <div v-html="errorText"></div>
      </CustomModal>

    </div>
  </Layout>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex';
  import moment from 'moment/src/moment';

  export default {
    name: 'user-licence',

    data() {
      return {
        busy: false,
        isSuccess: false,
        successText: '',
        isError: false,
        errorText: '',
        licenceCode: '',
        fieldPlaceholder: this.$t('licence.field_placeholder'),
        benefitItems: [
          this.$t('licence.benefit_item_1'),
          this.$t('licence.benefit_item_2'),
          this.$t('licence.benefit_item_3'),
          this.$t('licence.benefit_item_4'),
          this.$t('licence.benefit_item_5'),
        ],
      };
    },

    computed: {
      ...mapGetters({
        isUserLicence: 'isUserLicence',
        userLicence: 'userLicence',
        currentUserName: 'currentUserName',
      }),

      isLicenceCode() {
        return this.licenceCode;
      },

      licenceStartDate() {
        return moment(this.userLicence && this.userLicence.start_date).format('YYYY-MM-DD');
      },

      licenceEndDate() {
        return moment(this.userLicence && this.userLicence.end_date).format('YYYY-MM-DD');
      },

    },

    methods: {
      ...mapActions([
        'updatePromoCode',
      ]),

      submitLicenceCode() {
        this.$ga.event({
          eventCategory: 'ai_license',
          eventLabel: 'register_ai_license',
          eventAction: 'register',
        });
        this.busy = true;
        const licenceCode = {
          code: this.licenceCode,
        };

        this.updatePromoCode(licenceCode)
          .then(() => {
            this.isSuccess = true;
            this.successText = this.$t('licence.success_message', { startDate: this.licenceStartDate, endDate: this.licenceEndDate });
            return true;
          })
          .catch((err) => {
            this.isError = true;
            this.busy = false;
            if (err.response.status === 404) {
              this.errorText = this.$t('licence.error_message_1');
            }

            if (err.response.status === 409) {
              this.errorText = this.$t('licence.error_message_2');
            }
          });
      },
    },

    beforeMount() {
      this.$route.meta.title = this.$t('licence.title');
    },
  };
</script>

<style lang="scss" scoped>
  .user-licence-container {
    max-width: 946px;
    margin: 24px auto 24px;
    padding: 0px 14px 0px 14px;

    .user-licence {
      width: 100%;
      box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.1);
      background-color: #ffffff;
      height: 440px;

      .licence-icon {
        margin: 0 auto;
        display: block;
        padding: 44px 0px 14px 0;
      }

      .licence-title {
        font-size: 24px;
        line-height: 1.25;
        text-align: center;
        color: #836efe;
        margin-bottom: 44px;
      }

      .licence-card {
        position: relative;
        width: 296px;
        height: 195px;
        background: url('/static/images/img-licence-card.png') center center;
        background-repeat: no-repeat;
        background-size: cover;
        margin: 0 auto;

        .licence-card-title {
          text-shadow: 0 2px 0 rgba(0, 0, 0, 0.04);
          font-size: 19px;
          font-weight: 500;
          color: #ffffff;
          position: absolute;
          left: 24px;
          top: 4px;
        }

        .licence-card-subtitle {
          font-size: 13px;
          font-weight: 500;
          color: rgba(255, 255, 255, 0.6);
          position: absolute;
          left: 24px;
          bottom: 64px;
        }

        .licence-card-date {
          font-size: 13px;
          color: #ffffff;
          position: absolute;
          left: 24px;
          bottom: 44px;
        }
      }

      .form-group {
        max-width: 420px;
        margin: 0 auto;
        
        @media (max-width: 420px) {
          max-width: 320px;
        }

        .licence-code-field {
          height: 48px;
          border-radius: 4px;
          width: 100%;
          margin: 0 auto 14px;
          text-align: center;
        }
  
        .licence-code-btn {
          display: block;
          cursor: pointer;
          width: 100%;
          height: 48px;
          margin: 0 auto;
          font-size: 14px;
          text-align: center;
          color: #ffffff;
          border-radius: 4px;
          background-color: #726cf7;
          border: 0;
  
          &:disabled  {
            opacity: 0.6;
          }
        }
      }

    }

    .licence-benefit {
      max-width: 340px;
      margin: 0 auto;
      padding-bottom: 20px;

      .benefit-title {
        font-size: 18px;
        font-weight: 500;
        text-align: left;
        color: rgba(0, 0, 0, 0.87);
      }

      .benefit-item {
        font-size: 16px;
        text-align: left;
        color: rgba(0, 0, 0, 0.54);
        line-height: 1.75;

        img {
          margin-right: 8px;
        }
      }
    }
  }
</style>


// WEBPACK FOOTER //
// UserLicence.vue?063d58f7